export default {
  methods: {
    getMemberImage(image) {
      return require("../assets/images/website/members/" + image);
    },
    getWebsiteImage(image) {
      return require("../assets/images/website/" + image);
    },
    getAppImage(image) {
      return require("../assets/images/app/" + image);
    },
  },
};
